// components
import { NewDragDropUploader } from '@commons/components/NewDragDropUploader';

const DragAndDropUploaderModule = ({ showPanel = false }) => {
    return <NewDragDropUploader showPanel={showPanel} />;
};

export default DragAndDropUploaderModule;
